export default "__VITE_ASSET__DLIvaXle__"